import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="code-auto-submit"
export default class extends Controller {
  static targets = [
    'codeForm',
    'codeInput',
    'submit',
  ]

  declare readonly codeInputTarget: HTMLInputElement
  declare readonly codeFormTarget: HTMLFormElement
  declare readonly submitTarget: HTMLButtonElement

  connect (): void {
    this.codeFormTarget.addEventListener('keydown', this.preventDefault)
    this.codeInputTarget.addEventListener('keyup', this.checkCodeInputLength)
  }

  preventDefault = (event: KeyboardEvent): void => {
    if (event.key === 'Enter') {
      event.preventDefault()
    }
  }

  checkCodeInputLength = (): void => {
    if (this.codeInputTarget.value.length === 6) {
      this.codeInputTarget.removeEventListener('keyup', this.checkCodeInputLength)
      this.submitTarget.disabled = true
      this.submitTarget.value = 'Verifying...'
      this.submitTarget.classList.add('opacity-80')
      this.codeFormTarget.submit()
    }
  }
}
